import WutAvatarSdk from '../components/WutAvatar/corvid/WutAvatar.corvid';


const WutAvatar = {
  sdk: WutAvatarSdk
};


export const components = {
  ['WutAvatar']: WutAvatar
};

